<template>
  <div class="container">
    <loader v-if="isLoading"/>
    <template v-if="!isLoading">
      <div class="row top-head">
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
          <h1 class="referral-header">{{ $t('views.contest.referredFriendsContest') }}</h1>
          <h2 class="referral-header-desc">{{ $t('views.contest.referredFriendsContestPart2')}}</h2>
        </div>
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
          <img :src="getSrc('contest/top.svg')" alt=""/>
        </div>
      </div>
      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
        <div v-html="$t('views.contest.descInfo')"></div>
        </div>
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
          <div class="example-card" style="height: 100px">
            <br>
            <div class="search">
              <div class="search-block">
                <input type="search"
                       v-model="searchPhrase"
                       class="search-input"
                       oninput="(this.value = !isNaN(parseInt(this.value)) ? parseInt(this.value) : '')"
                       :placeholder="$t('views.contest.searchPlaceHolder')"
                       :aria-label="$t('views.contest.searchPlaceHolder')"
                       :style="{ backgroundImage: 'url('+ getSrc('search.png')+')' }"/>
              </div>
            </div>
            <br/>
          </div>
        </div>
      </div>
      <br/>
      <div class="example-card">
        <b-table
            :items="loadContestData"
            :fields="tableFields"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="searchPhrase"
            :tbody-tr-class="rowClass"
            class="w-100 contest-table2 income-table"
            hover
            borderless
            responsive="sm">
          <template v-slot:head()="data">
            <span class="table-header">{{ $t(data.label) }}</span>
          </template>
          <template v-slot:cell(potential_prize)="item">
          <span :class="{ 'text-bold': item.item.place === 1}">
            {{ item.value | moneyFormatterWithoutCents }}
          </span>
          </template>
          <template #cell(place)="{ item }">
            <span class="blue-text" :class="{ 'text-bold': item.place === 1}" href="">{{ item.place }} </span>
          </template>
          <template #cell(investor_id)="{ item }">
            <span class="blue-text" :class="{ 'text-bold': item.place === 1}" href="">{{ item.investor_id }} </span>
          </template>
          <template #cell(refferedCount)="{ value, item}">
            <span :class="{ 'text-bold': item.place === 1}">{{ value }}</span>
          </template>
          <template #cell(prize)="{ value, item }">
            <span :class="{ 'text-bold': item.place === 1}">{{ value }}</span>
          </template>
        </b-table>
        <div>
          <b-pagination align="right" class="income-pagination"
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="perPage"
                        size="sm"
          ></b-pagination>
        </div>
      </div>
      <br/>
      <p>{{ $t('views.contest.checkOutPart1')}}<a href="/invite"><strong>{{ $t('views.contest.here') }}</strong></a>{{ $t('views.contest.checkOutPart2')}}</p>
      <p v-html="$t('views.contest.nb')"/>
    </template>
  </div>
</template>

<script>
import moneyMixin from '../mixins/money'
import Loader from '@/components/Loader'
import imageMixin from '@/mixins/image'
import Contest from '@/api/contest'

export default {
  components: {Loader},
  mixins: [moneyMixin, imageMixin],
  data()
  {
    return {
      isLoading: false,
      searchPhrase: '',
      totalRows: 20,
      currentPage: 1,
      perPage: 20,
      tableData: {},
      tableFields: [
        {
          key: 'place',
          label: 'views.contest.place',
          class: 'place-number text-center'
        },
        {
          key: 'investor_id',
          label: 'views.contest.investor',
          class: 'investor-name'
        },
        {
          key: 'friends_referred',
          label: 'views.contest.friendsReferred',
          class: 'text-center'
        },
        {
          key: 'potential_prize',
          label: 'views.contest.potentialPrize',
          class: 'text-center'
        }
      ]
    }
  },
  methods:
      {
        rowClass(item, type)
        {
          if (!item || type !== 'row')
          {
            return
          }
          if (item.isFirst === true)
          {
            return 'firstPlace'
          }
        },
        loadContestData(ctx)
        {
          const promise = Contest.get(ctx.currentPage, this.searchPhrase)
          this.isLoading = false
          return promise.then((response) =>
          {
            this.totalRows = response.total
            return response.data
          }).catch(error =>
          {
            console.log(error)
            return []
          })
        }
      }
}
</script>

<style lang="scss">
.contest-table {
  .place-number,
  .investor-name {
    color: #30A7FE !important;
  }

  .firstPlace {
    font-weight: bold;
  }
}
</style>
<style scoped lang="scss">
.blue-text {
  color: #30A7FE;
}

.top-head {
  margin-bottom: 15px;
}

.referral-header {
  font-family: Open Sans, serif;
  font-style: normal;
  font-weight: bold;
  font-size: 64px;
  line-height: 87px;
  color: #071D2D;
}

.referral-header-desc {
  font-family: Open Sans, serif;
  font-style: normal;
  font-weight: bold;
  font-size: 44px;
  line-height: 60px;
  color: #071D2D;
}

.table-header {
  font-style: normal;
  font-weight: bold;
  font-size: 13px;
  line-height: 10px;
  text-align: center;
  /*text-transform: uppercase;*/
  color: #9DA0A6;
}

.table-cell {
  font-style: normal;
  line-height: 10px;
}

.search-block {
  min-width: 255px;
  background: #FFFFFF;
  //box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  z-index: 2;

  input {
    background: #E2F3FF;
    border: none;
    box-sizing: border-box;
    border-radius: 16px;
    width: 100%;
    height: 48px;
  }

  .search-input {
    background-repeat: no-repeat;
    padding-left: 35px;
    background-position: 5px;
    font-size: 16px;
    line-height: 22px;
  }
}
</style>
